import axios from '../utils/axios';

export default function distributeCredits(adminId, mgr_id, data) {
    return (
        axios.post('/admin/' + adminId + '/credits/manager/' + mgr_id + '/distribute', data)
    )
}
